// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var DdtsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function DdtsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get Ddts list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    DdtsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'ddts', params);
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    DdtsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'ddts/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given ddtId data from back-end
     *
     * @since 1.0.0
     *
     * @param ddtId ID of the ddt to get
     */
    DdtsService.prototype.get = function (ddtId) {
        var _this = this;
        return this.apiService.apiCall('GET', "ddts/" + ddtId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update ddt with given ddtId with given ddt data
     *
     * @since 1.0.0
     *
     * @param ddtId ID of ddt to update
     * @param data New ddt's data
     */
    DdtsService.prototype.update = function (ddtId, data) {
        return this.apiService.apiCall('PUT', "ddts/" + ddtId, data);
    };
    /**
    * Get given checklist list
    *
    * @since 1.0.0
    *
    */
    DdtsService.prototype.getChecklist = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "ddts/checklist").pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given checklist detail
     *
     * @since 1.0.0
     *
     */
    DdtsService.prototype.getChecklistDetail = function (ddtId) {
        var _this = this;
        return this.apiService.apiCall('GET', "ddts/checklist/" + ddtId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
    * Get ddtDocuments by code
    *
    * @since 1.0.0
    *
    */
    DdtsService.prototype.getDdtdocumentByCode = function (code) {
        var _this = this;
        return this.apiService.apiCall('GET', "ddts/ddt-documents/" + code).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    DdtsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DdtsService_Factory() { return new DdtsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: DdtsService, providedIn: "root" });
    return DdtsService;
}());
export { DdtsService };
